import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EditOutlined } from '@ant-design/icons';
import { Descriptions, Button, Alert, Divider, Comment, Drawer, Row, Col, Switch } from 'antd';
import { Form } from "@ant-design/compatible";
import ReactHtmlParser from 'react-html-parser';
import { fetchPost, updatePost } from '@/redux/actions/postActions';
import { checkPermission } from '@/utils/permission';
import { isMobile } from 'react-device-detect';
import { isValidDate } from '@/utils/helpers';
import PostForm from './PostForm';

class PostDetail extends Component {
    state = {
        isOpenEditForm: false,
        currentPost: null,
    }

    toggleOpenEditForm(isOpenEditForm, post = null) {
        this.setState({
            isOpenEditForm: isOpenEditForm,
            currentPost: post
        });
    }

    onEdit(id) {
        this.props.fetchPost(id).then((res) => {
            this.toggleOpenEditForm(true, res)
        })
    }

    render() {
        var { currentData, visible } = this.props;
        var {
            isOpenEditForm,
            currentPost,
        } = this.state;

        return (
            <div>
                <Drawer
                    visible={visible}
                    title={`#${currentData?.id}`}
                    width={isMobile ? '100%' : '65%'}
                    onClose={() => this.props.onCancel()}
                    maskClosable={false}
                    footer={false}
                    extra={
                        <>
                            {
                                checkPermission('posts', 'update') ? <><Button type="primary" className='fix-buttom-mobile' onClick={() => this.onEdit(currentData?.id)} icon={<EditOutlined />}>Sửa</Button></> : null
                            }
                        </>
                    }
                >
                    {visible && currentData ? (
                        <>
                            <Row gutter={16}>
                                <Col xs={24} md={24} className='mt-2'>
                                    <Comment
                                        author={<span className='ant-descriptions-item-label'>Tên bài viết</span>}
                                        content={<>{currentData?.title}</>}
                                    />
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24} className='mt-2'>
                                    <Comment
                                        author={<span className='ant-descriptions-item-label'>Tiêu đề hiển thị</span>}
                                        content={<>{currentData?.header}</>}
                                    />
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24} className='mt-2'>
                                    <Comment
                                        author={<span className='ant-descriptions-item-label'>Từ khóa</span>}
                                        content={<>{currentData?.keyword}</>}
                                    />
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24} className='mt-2'>
                                    <Comment
                                        author={<span className='ant-descriptions-item-label'>Tên miền sử dụng</span>}
                                        content={<>{currentData?.domain_used}</>}
                                    />
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24} className='mt-3'>
                                    <Comment
                                        author={<span className='ant-descriptions-item-label'>Nội dung đã biên tập</span>}
                                        content={<>{ReactHtmlParser(currentData?.edited_content)}</>}
                                    />
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24} className='mt-3'>
                                    <Comment
                                        author={<span className='ant-descriptions-item-label'>Nội dung gốc</span>}
                                        content={<>{ReactHtmlParser(currentData?.origin_content)}</>}
                                    />
                                </Col>
                                <Col xs={24} md={24} className='wrap-alert'>
                                    <Alert
                                        message={<strong>Ghi chú</strong>}
                                        description={ReactHtmlParser(currentData?.note)}
                                        type="info"
                                        className='fix-alert-element'
                                    />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small" className='mt-3'>
                                        <Descriptions.Item label="Tình trạng">
                                            <Switch
                                                checked={Boolean(currentData.status)}
                                                disabled={!checkPermission('posts', 'update')}
                                                checkedChildren="Đã hoàn thiện"
                                                unCheckedChildren="Chưa hoàn thiện"
                                                onChange={(value) => this.props.updatePost(currentData.id, { status: value })
                                                    .then(() => this.props.reloadData())}
                                            />
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ngày tạo">
                                            {isValidDate(currentData?.created_at)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ngày cập nhật">
                                            {isValidDate(currentData?.updated_at)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Người tạo">
                                            {currentData?.created_user}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Người cập nhật">
                                            {currentData?.updated_user}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                        </>
                    ) : null
                    }
                </Drawer>
                <PostForm
                    visible={isOpenEditForm}
                    currentData={currentPost}
                    onCancel={() => this.toggleOpenEditForm(false)}
                    reloadData={() => this.props.reloadData()}
                />
            </div >
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchPost: id => dispatch(fetchPost(id)),
        updatePost: (id, data) => dispatch(updatePost(id, data))
    }
}
export default connect(null, mapDispatchToProps)(Form.create({ name: "PostDetail" })(PostDetail));
